import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-solid-svg-icons';

import { LeaseMediaLinksPropTypes } from 'bundles/project/components/media_tab/media_props_types';

export default function LeaseMediaLinks({ mediaLinksFormFields, onFormChange }) {
  return (
    <div className="lease-media-links-container">
      <h3 className="mt-5 mb-5">
        <FontAwesomeIcon className="text-primary mr-2" icon={faLink} />
        Links
      </h3>

      <div className="form-group">
        <label className="control-label">Video URL</label>
        <div className="form-input-container">
          <input
            className="form-control"
            placeholder="Enter video url from youtube or vimeo"
            value={mediaLinksFormFields.videoUrl}
            onChange={e => onFormChange('videoUrl', e.target.value)}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="control-label">Matterport Showcase Link</label>
        <div className="form-input-container">
          <input
            className="form-control"
            placeholder="Enter Matterport Showcase link"
            value={mediaLinksFormFields.matterportUrl}
            onChange={e => onFormChange('matterportUrl', e.target.value)}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="control-label">Virtual Tour URL</label>
        <div className="form-input-container">
          <input
            className="form-control"
            placeholder="Enter virtual tour link (non-Matterport)"
            value={mediaLinksFormFields.virtualTourUrl}
            onChange={e => onFormChange('virtualTourUrl', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

LeaseMediaLinks.propTypes = {
  mediaLinksFormFields: LeaseMediaLinksPropTypes.isRequired,
  onFormChange: PropTypes.func.isRequired
};
